import React, { useEffect } from "react"
import ko from 'knockout'
import ViewModel from '../../ko/view-model'
import OutputContainer from '../output/OutputContainer'


import './Main.scss'

function Main ({selector, model}) {

  var vm = new ViewModel(model)

  if (typeof window !== "undefined"){
    switch (model) {
      case "Species":
        if (Window.vms == undefined) {
          Window.vms = vm
        }
        break;

      case "Gear":
        if (Window.vmg == undefined) {
          Window.vmg = vm
        }
        break;

      case "Charter":
        if(Window.vmc == undefined) {
          Window.vmc = vm
        }

        break;
    
      default:
        if (Window.vms == undefined) {
          Window.vms = vm
        }
        break;
    }
  }

  useEffect(() => {

    ko.applyBindings(vm, document.querySelector(selector))

    return () => {
      Window.vms = undefined
      Window.vmg = undefined
      Window.vmc = undefined
      ko.cleanNode(document.querySelector(selector))
    }
  },[])

  return (

    <div className="Main">
      <OutputContainer model={model} />
    </div>
  )

}  
export default Main